import { useMemo } from "react";

import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";
import { BucketOfLearninRow } from "./BucketOfLearninRow";

export const LevelRow = ({ metadata, details, variant, currentPaths = [] }) => {
  const { isLoadingLevelDetails } = useLevelContext();

  if (details?.error) {
    return null;
  }

  // Filter out paths that the user is already enrolled in based on roleId
  const filteredDetails = useMemo(() => {
    if (!currentPaths?.length || !details?.length) {
      return details;
    }

    // Create a Set of enrolled roleIds for fast lookup
    const enrolledRoleIds = new Set(
      currentPaths.filter(path => path.roleId != null).map(path => path.roleId)
    );

    // Filter out paths where the role.id matches an enrolled roleId
    return details.filter(path => {
      const pathRoleId = path?.id;
      return pathRoleId == null || !enrolledRoleIds.has(pathRoleId);
    });
  }, [details, currentPaths]);

  const isLoading =
    isLoadingLevelDetails ||
    details === undefined ||
    (details !== undefined && filteredDetails === undefined);

  // SHRPA-2293 -- Variant will be stored at "Level" level, until then this logic lives here
  const getVariantName = variant => {
    switch (variant) {
      case 0:
        return "indigo";
      case 1:
        return "blue";
      case 2:
        return "teal";
      case 3:
      default:
        return "mauve";
    }
  };
  const variantName = getVariantName(variant);

  return (
    <BucketOfLearninRow
      loading={isLoading}
      id={metadata.id}
      name={metadata.name}
      description={metadata.description}
      learnins={filteredDetails}
      details={filteredDetails}
      variant={variantName}
      currentPaths={currentPaths}
      type="level"
    />
  );
};

export const LevelPaths = ({ currentPaths }) => {
  const { levels, levelsLoading, levelDetails } = useLevelContext();
  if (levelsLoading) {
    return null;
  }

  const filteredLevels = levels.filter(level => !["brown", "black"].includes(level.rankName));

  return (
    <div className="my-8">
      {filteredLevels.map((level, index) => (
        <LevelRow
          key={level.id}
          metadata={level}
          details={levelDetails[level.id]}
          variant={index % 4}
          currentPaths={currentPaths}
        />
      ))}
    </div>
  );
};
